import React, { useEffect, useState, useRef } from "react";
import { fetchActiveAnnouncements } from "./announcementService";

/**
 * Dev logger (hidden in production)
 */

const ROTATION_INTERVAL = 5000; // 5 seconds
const BLINK_INTERVAL = 700; // 0.7 seconds for blinking

const AnnouncementBar = () => {

 const [announcements, setAnnouncements] = useState([]);
 const [currentIndex, setCurrentIndex] = useState(0);
 const [visible, setVisible] = useState(true);
 const [blink, setBlink] = useState(true);

 const rotationRef = useRef(null);
 const blinkRef = useRef(null);

 /**
 * Fetch announcements on mount
 */
 useEffect(() => {
 
 fetchAnnouncements();

 return () => {
 
 stopRotation();
 stopBlinking();
 };
 }, []);

 /**
 * Start rotation when announcements available
 */
 useEffect(() => {
 if (announcements.length > 1) {
 
 startRotation();
 }
 return () => stopRotation();
 }, [announcements]);

 /**
 * Start blinking when announcements available
 */
 useEffect(() => {
 if (announcements.length > 0) {
 startBlinking();
 }
 return () => stopBlinking();
 }, [announcements, currentIndex]);

 /**
 * Fetch active announcements from backend
 */
 const fetchAnnouncements = async () => {
 try {
 
 const response = await fetchActiveAnnouncements();

 if (!response.success) {
 
 setAnnouncements([]);
 return;
 }

 const data = response.data;
 

 if (!Array.isArray(data) || data.length === 0) {
 
 setAnnouncements([]);
 return;
 }

 // Sort by priority (highest first)
 const sorted = [...data].sort((a, b) => b.priority - a.priority);
 
 setAnnouncements(sorted);

 } catch (error) {
 
 setAnnouncements([]);
 }
 };

 /**
 * Start auto rotation
 */
 const startRotation = () => {
 stopRotation();
 rotationRef.current = setInterval(() => {
 setCurrentIndex(prev => {
 const nextIndex = (prev + 1) % announcements.length;
 
 return nextIndex;
 });
 }, ROTATION_INTERVAL);
 };

 const stopRotation = () => {
 if (rotationRef.current) {
 
 clearInterval(rotationRef.current);
 rotationRef.current = null;
 }
 };

 /**
 * Blinking effect
 */
 const startBlinking = () => {
 stopBlinking();
 blinkRef.current = setInterval(() => {
 setBlink(prev => !prev);
 }, BLINK_INTERVAL);
 };

 const stopBlinking = () => {
 if (blinkRef.current) {
 clearInterval(blinkRef.current);
 blinkRef.current = null;
 setBlink(true); // reset to visible
 }
 };

 /**
 * Close announcement bar
 */
 const closeBar = () => {
 
 setVisible(false);
 stopRotation();
 stopBlinking();
 };

 /**
 * Navigate to link if available
 */
 const onClick = () => {
 const announcement = announcements[currentIndex];
 if (announcement?.link) {
 
 window.open(announcement.link, "_blank");
 } else {
 
 }
 };

 /**
 * Don't render if no announcements or hidden
 */
 if (!visible || announcements.length === 0) {
 
 return null;
 }

 const current = announcements[currentIndex];

 return (
 <div
 style={{
 background: current.backgroundColor || "#0d6efd",
 color: current.textColor || "#ffffff",
 padding: "10px 16px",
 display: "flex",
 alignItems: "center",
 justifyContent: "space-between",
 cursor: current.link ? "pointer" : "default",
 fontSize: "14px",
 fontWeight: "500",
 opacity: blink ? 1 : 0.3, // blinking effect
 transition: "opacity 0.3s ease-in-out"
 }}
 onClick={onClick}
 >
 {/* Message */}
 <div style={{ flex: 1, textAlign: "center" }}>
 {current.message}
 </div>

 {/* Close Button */}
 <button
 onClick={closeBar}
 style={{
 background: "transparent",
 border: "none",
 color: current.textColor || "#ffffff",
 fontSize: "18px",
 cursor: "pointer",
 marginLeft: "10px"
 }}
 >
 ×
 </button>
 </div>
 );
};

export default AnnouncementBar;
